module.exports = __webpack_public_path__ + "media/assets/images/icons/Download-Icon-9481dc8cc082af1fff4c19ef6e763b26.svg";